<template>
<div>
    <div class="flex flex-row justify-between mt-4 mb-8">

      <div v-if="borderRadiusShouldShow" class="w-24 h-24 relative bg-secondary radius-all mt-1">
        <div class="flex" v-for="targetCat in [[0,1],[3,2]]" :key="`cat-${targetCat[0]}`">
          <div
            v-for="target in targetCat"
            :key="`target-${target}`"
            class="w-1/2 h-12 cursor-pointer transition"
            :class="[
              `radius-${target}`,
              {
                'bg-primary': cornerSelected(target),
                'border-b border-r border-secondary-darker' : target === 0,
                'border-t border-l border-secondary-darker' : target === 2
              }
            ]"
            @click="select(target)"
          >
            <div
              class="w-7 h-7 flex items-center cursor-pointer text-xs absolute transition"
              :class="{
                'text-primary':cornerSelected(target),
                'text-secondary-invert':!cornerSelected(target),
                'right-0' : [1,2].includes(target),
                'justify-start' : [1,2].includes(target),
                'justify-end' : [0,3].includes(target),
              }"
              :style="{
                top : [1,0].includes(target)?'-1.3rem':'none',
                bottom : [2,3].includes(target)?'-1.5rem':'none'
              }"
            >{{ properties.radius[target]}}px</div>
          </div>
        </div>

        <div class="bg-secondary-darker text-secondary-invert centerselector radius">
          <span class="cursor-pointer"
            v-tooltip="{classes:'custom-tooltip', content: this.$t('frontend_select_all')}"
            @click="toggleSelectAll(false)"
          >
            {{this.$t('frontend_builder_border_section_corners')}}
          </span>
        </div>
      </div>

      <div v-if="borderWidthShouldShow" class="w-24 h-24 relative bg-secondary mr-1" style="top:4px">
        <div
          v-for="target in [0, 3, 1, 2]"
          :key="target"
          class="w-7 h-7 cursor-pointer absolute text-xs transition"
          :class="{
            'text-primary':borderSelected(target),
            'text-secondary-invert':!borderSelected(target)
          }"
          @click="select(target,true)"
          :style="{
            top : (target ==0)?'-2px':(target == 3)?'40%':(target == 1)?'35%':'none',
            left : [0, 2].includes(target)?'50%':(target === 3)?'-18px':'none',
            right : [0, 2].includes(target)?'50%':(target === 1)?'-18px':'none',
            transform : [0, 2].includes(target)?'translate(-50%,-50%)':(target === 3)?'rotate(270deg)':(target === 1)?'rotate(90deg)':'none',
            bottom : (target ==  2)?'-43px':'none',
          }"
        >{{ properties.width[target] }}px</div>

        <div class="w-full h-full relative overflow-hidden">
          <div
            v-for="(target,i) in [0, 3, 1, 2]"
            :key="target"
            class="cursor-pointer transition"
            :class="[
              `tri-${i + 1}`
              ,{
                'border-t border-l border-secondary-darker' : [0, 2].includes(target),
                'bg-primary': borderSelected(target)
              }
            ]" 
            @click="select(target,true)"
          ></div>
        </div>

        <div class="bg-secondary-darker text-secondary-invert centerselector">
          <span class="cursor-pointer"
            v-tooltip="{classes:'custom-tooltip', content: this.$t('frontend_select_all')}"
            @click="toggleSelectAll(true)"
          >
            {{this.$t('frontend_builder_border_section_width')}}
          </span>
        </div>
      </div>
    </div>
    <div class="flex flex-col flex-1 flex-grow mt-4" v-if="!sideIsSelected && this.selected.length">
        <div class="text-xs font-bold text-secondary-invert">
            {{ this.$t('frontend_builder_border_section_radius') }}
        </div>
        <gd-slider
            v-model="borderRadius"
            size="full"
            :min="0"
            :max="100"
            :readonly="false"
            step="1"
          />
    </div> 
    <panel-column-layout
      v-if="sideIsSelected  && this.selected.length"
      columns="2"
      class="mt-4"
    >
      <template slot="first">
        <div 
          v-if="shouldShow('borderWidth')"
          class="flex flex-col flex-1 flex-grow"
          data-cy="borderWidth"
        >
          <div class="text-xs font-bold text-secondary-invert">
            {{ this.$t('frontend_builder_border_section_width') }}
          </div>
          <gd-slider
            v-model="borderWidth"
            size="full"
            :min="0"
            :max="30"
            :readonly="false"
            step="1"
          />
        </div>
      </template>
      <template slot="second">
        <div 
          v-if="shouldShow('borderColor')"
          class="flex flex-col flex-1 flex-grow"
          data-cy="borderColor"
        >
          <div class="text-xs font-bold text-secondary-invert">
            {{ this.$t('frontend_builder_border_section_color') }}
          </div>
          <color-picker
            v-model="borderColor"
            data-cy="colorPicker"
            :colors="properties.borderLeftColor"
          ></color-picker>
        </div>
      </template>
    </panel-column-layout>
    
    <div v-if="borderSelected(0) || borderSelected( 2) || borderSelected( 3) || borderSelected( 1)">
      <gd-separator />
      <div class="flex flex-row mb-2">
        <div class="text-xs font-bold text-secondary-invert flex items-center pr-12">
          {{ $t('frontend_builder_border_section_style') }}
        </div>
        <sides-panel
          v-model="borderStyle"
          :sides="borderStyles"
        ></sides-panel>
      </div>
    </div>
  </div>
</template>
<script>
import GdDropdown from '@groovepages/gd-ui-kit/components/Dropdown';
import GdButton from '@groovepages/gd-ui-kit/components/Button';
import GdSlider from '@groovepages/gd-ui-kit/components/Slider';
import SidesMultiDropdownPanel from '@groovepages/gd-ui-kit/components/SidesMultiDropdownInput';
import SidesDropdownPanel from '@groovepages/gd-ui-kit/components/SidesDropdownInput';
import SidesPanel from '@groovepages/gd-ui-kit/components/SidesSelectorInput';
import ColorPicker from '@groovepages/gd-ui-kit/components/ColorPicker'
import GdSeparator from '@groovepages/gd-ui-kit/components/Separator';
import PanelColumnLayout from './PanelColumnLayout';
import GdToggle from '@groovepages/gd-ui-kit/components/Toggle';
import { VTooltip } from 'v-tooltip';

// import icons from gd-ui-kit
import CloseIcon from '@groovepages/gd-ui-kit/assets/close-icon.svg';
import BorderSolid from '@groovepages/gd-ui-kit/assets/border-solid.svg';
import BorderDashed from '@groovepages/gd-ui-kit/assets/border-dashed.svg';
import BorderDotted from '@groovepages/gd-ui-kit/assets/border-dotted.svg';

export default {
  components: {
    GdDropdown,
    GdButton,
    GdSlider,
    SidesMultiDropdownPanel,
    SidesPanel,
    SidesDropdownPanel,
    ColorPicker,
    GdSeparator,
    PanelColumnLayout,
    GdToggle
  },
  directives: { tooltip: VTooltip },
  props: {
    styles: {
      required: true,
    },
  },
  data() {
    return {
      selected: [0, 3, 1, 2],
      sideIsSelected: true,
      lastSelected: 'side',
      selectAll: false,
      properties: this.styles,
      borderStyles: {
        none: CloseIcon,
        solid: BorderSolid,
        dashed: BorderDashed,
        dotted: BorderDotted
      },
    };
  },
  computed: {
    borderWidthShouldShow() {
      return (
        this.shouldShow('borderLeftWidth') ||
        this.shouldShow('borderRightWidth') ||
        this.shouldShow('borderTopWidth') ||
        this.shouldShow('borderBottomWidth')
      );
    },
    borderColorShouldShow() {
      return (
        this.shouldShow('borderLeftColor') ||
        this.shouldShow('borderRightColor') ||
        this.shouldShow('borderTopColor') ||
        this.shouldShow('borderBottomColor')
      );
    },
    borderStyle: {
      get() {
        return this.properties.style[this.selected[this.selected.length - 1]]
      },
      set(value) {
        this.selected.forEach(side => {
          this.$set(this.properties.style, side, value);
        });
      },
    },
    borderColor: {
      get() {
        return this.properties.color[this.selected[this.selected.length - 1]]
      },
      set(value) {
        this.selected.forEach(side => {
          this.$set(this.properties.color, side, value);
        });
      },
    },
    borderRadiusShouldShow() {
      return (
        this.shouldShow('borderTopLeftRadius') ||
        this.shouldShow('borderTopRightRadius') ||
        this.shouldShow('borderBottomLeftRadius') ||
        this.shouldShow('borderBottomRightRadius')
      );
    },
    borderRadius: {
      get() {
        return this.properties.radius[this.selected[this.selected.length - 1]];
      },
      set(value) {
        this.selected.forEach(side => {
          this.$set(this.properties.radius, side, value);
        });
      },
    },
    borderWidth: {
      get() {
        return this.properties.width[this.selected[this.selected.length - 1]];
      },
      set(value) {
        this.selected.forEach(side => {
          this.$set(this.properties.width, side, value);
        });
      }
    },
  },
  watch: {
    properties: {
      deep: true,
      handler(){
        console.log(this.properties.width);
        this.$emit('change', this.properties);
      }
    }
  },
  methods: {
    shouldShow(aa){
      return true;
    },
    toggleSelectAll(isSide){
      if(!this.selectAll && this.selected.length !== 4){
        this.selectAll = true;
        if(isSide){
          this.sideIsSelected = true
          this.lastSelected = 'side'
          this.selected = [0, 3, 1, 2]
        }
        else{
          this.sideIsSelected = false
          this.lastSelected = 'corner'
          this.selected = [0,1,3,2]
        }
      }else {
        if((this.sideIsSelected && isSide) || (!this.sideIsSelected && !isSide)) {
          this.selectAll = false
          this.selected = []
        }else {
          if(isSide){
            this.sideIsSelected = true
            this.lastSelected = 'side'
            this.selected = [0, 3, 1, 2]
          }
          else{
            this.sideIsSelected = false
            this.lastSelected = 'corner'
            this.selected = [0,1,3,2]
          }
        }
      }
    },
    select(side, isSide) {
      let removed = false;
      if (
        this.selected &&
        this.selected.includes(side) &&
        !!isSide === this.sideIsSelected
      ) {
        this.selected = this.selected.filter((entry) => {
          if (entry === side) {
            removed = true;
            return false;
          }
          return true;
        });
      }
      if (!this.selected.length) {
        this.selected = [];
      }
      if (
        (this.lastSelected === 'side' && !isSide) ||
        (this.lastSelected === 'corner' && isSide)
      ) {
        this.selected = [];
      }
      if (!removed) this.selected.push(side);
      if (isSide) {
        this.lastSelected = 'side';
        this.sideIsSelected = true;
      } else {
        this.lastSelected = 'corner';
        this.sideIsSelected = false;
      }
      this.selectAll = false
    },
    borderSelected(side) {
      if (!this.sideIsSelected) return false;
      if (this.selected && this.selected.includes(side)) return true;
      return false;
    },
    cornerSelected(side) {
      if (this.sideIsSelected) return false;
      if (this.selected && this.selected.includes(side)) return true;
      return false;
    }
  },
};
</script>
<style lang="scss">
  .custom-tooltip {
    display: block !important;
    z-index: 10000;

    .tooltip-inner {
      background: var(--brand-primary);
      color: var(--brand-primary-invert);
      border-radius: 4px;
      font-size: 12px;
      padding: 5px 10px 4px;
      max-width: 260px;
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: var(--brand-primary);
      z-index: 1;
    }

    &[x-placement^='0'] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^='2'] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^='1'] {
      margin-left: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[x-placement^='3'] {
      margin-right: 5px;

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &.popover {
      $color: #f9f9f9;

      .popover-inner {
        background: $color;
        color: black;
        padding: 24px;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(black, 0.1);
      }

      .popover-arrow {
        border-color: $color;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity 0.15s, visibility 0.15s;
    }

    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity 0.15s;
    }
  }
</style>
<style lang="scss">
.tri-1,
.tri-2,
.tri-3,
.tri-4 {
  position: absolute;
  height: calc(100% / 1.414);
  width: calc(100% / 1.414);
  top: 50%;
  left: 50%;
  transform-origin: 0% 0%;
}
.tri-3 {
  transform: rotate(-45deg);
}
.tri-4 {
  transform: rotate(45deg);
}
.tri-1 {
  transform: rotate(-135deg);
}
.tri-2{
  transform: rotate(135deg);
}

.centerselector {
  position: absolute;
  top: 6px;
  left: 6px;
  right: 6px;
  bottom: 6px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
  
  &.radius {
    border-radius: 25px;
  }
}

.radius-0 {
  border-radius: 31px 0 0 0;
}
.radius-1 {
  border-radius: 0 31px 0 0;
}
.radius-3 {
  border-radius: 0 0 0 31px;
}
.radius-2 {
  border-radius: 0 0 31px 0;
}
.radius-all {
  border-radius: 31px;
}
.radius-0,
.radius-1,
.radius-2,
.radius-3,
.tri-1,
.tri-2,
.tri-3,
.tri-4 {
  
  &:not(.bg-primary).hover {
    background-color: #fd648180
  }
}
.transition {
  transition: all ease .5s;
}
</style>
